import * as Dialog from "@radix-ui/react-dialog";
import { ReactComponent as CloseIcon } from "assets/img/icons/header/close.svg";

interface FullscreenFileModalProps {
    embedUrl: string | null;
    trigger: React.ReactNode;
}

export const FullscreenFileModal = ({ embedUrl, trigger }: FullscreenFileModalProps) => {
    return (
        <Dialog.Root>
            <Dialog.Trigger asChild>{trigger}</Dialog.Trigger>
            <Dialog.Portal>
                <Dialog.Overlay className="fixed inset-0 z-50 bg-[#424242]/75 backdrop-blur-sm" />
                <Dialog.Content className="fixed left-1/2 top-1/2 z-50 h-[95vh] w-[95vw] max-w-6xl -translate-x-1/2 -translate-y-1/2 rounded-2xl bg-white p-5 outline-none">
                    <div className="flex items-center justify-end">
                        <Dialog.Close asChild>
                            <button aria-label="Close">
                                <CloseIcon className="h-[30px] w-[30px]" />
                            </button>
                        </Dialog.Close>
                    </div>

                    <hr className="-mx-[20px] my-4 border-[#c8c8c8]" />

                    <div className="h-[calc(100%-48px)] w-full  ">
                        {embedUrl && (
                            <iframe src={embedUrl} className="h-full w-full border-0 "></iframe>
                        )}
                    </div>
                </Dialog.Content>
            </Dialog.Portal>
        </Dialog.Root>
    );
};
